import { useNavigate } from 'react-router-dom';
import { useAuth } from '@sv/shared/auth';

export function ProfilePage() {
  const { user, logout, isLoggingOut } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  if (!user) return null;

  return (
    <div className="mx-auto max-w-2xl space-y-6 p-8">
      <div className="flex items-center justify-between">
        <h1 className="text-2xl font-semibold text-foreground">SV Tera Coach</h1>
        <button
          type="button"
          onClick={handleLogout}
          disabled={isLoggingOut}
          className="rounded-md border px-4 py-2 text-sm font-medium text-foreground hover:bg-muted disabled:opacity-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          {isLoggingOut ? 'Signing out…' : 'Log out'}
        </button>
      </div>

      <div className="rounded-lg border bg-card p-6 shadow-sm">
        <h2 className="mb-4 text-lg font-medium text-card-foreground">User information</h2>
        <dl className="grid grid-cols-[max-content_1fr] gap-x-6 gap-y-2 text-sm">
          <dt className="font-medium text-muted-foreground">ID</dt>
          <dd className="text-foreground">{user.id}</dd>
          <dt className="font-medium text-muted-foreground">Username</dt>
          <dd className="text-foreground">{user.username}</dd>
          <dt className="font-medium text-muted-foreground">Slug</dt>
          <dd className="text-foreground">{user.slug}</dd>
          <dt className="font-medium text-muted-foreground">Timezone</dt>
          <dd className="text-foreground">{user.timezone}</dd>
          <dt className="font-medium text-muted-foreground">Language</dt>
          <dd className="text-foreground">{user.language}</dd>
        </dl>
      </div>

      <details className="rounded-lg border bg-card p-6 text-sm shadow-sm">
        <summary className="cursor-pointer font-medium text-card-foreground">
          Raw /api/v3/users/self response
        </summary>
        <pre className="mt-4 overflow-x-auto rounded bg-muted p-4 text-xs text-muted-foreground">
          {JSON.stringify(user, null, 2)}
        </pre>
      </details>
    </div>
  );
}
